import moment from 'moment';
import type { IImportJob } from '../../extViewmodels/sdk/models';

// Plain milliseconds, not moment.duration: AdminViewModels loads this module, and specs that partially mock moment have no duration().
const RevertEventWindowMs = 60 * 24 * 60 * 60 * 1000;

/**
 * True when the import is past the API's 60-day event window, where only a created-contacts-only revert is accepted.
 * Measured from `dateLastUpdatedUtc`, matching the API.
 */
export function requiresCreatedContactsOnlyRevert(job: IImportJob | undefined, now = moment()): boolean {
	if (!job?.dateLastUpdatedUtc) {
		return false;
	}
	return now.diff(moment.utc(job.dateLastUpdatedUtc)) > RevertEventWindowMs;
}
